import Login from '../components/Login';

export default function login() {
  return (
    <>
      <Login />
    </>
  );
}

export const getServerSideProps = async () => {
  return {
    props: {}
  };
};
